import { connect } from 'react-redux';

import RegistrationCodesScreen from '../components/RegistrationCodesScreen';
import storage from '../../../../../lib/Storage';
import { findStorageType } from '../../../../../lib/Auth';

const mapStateToProps = (state) => {
  return {
    total: state.registrationCodes.get('total'),
    isLoading: state.registrationCodes.get('isLoading'),
    partnershipName: storage.get(findStorageType(), 'partnershipName'),
    partnershipId: storage.get(findStorageType(), 'partnershipId'),
    access_role_admin_in_app: storage.get(findStorageType(), 'partnershipData')
      ?.access_role_admin_in_app,
    role: storage.get(findStorageType(), 'partnershipData')?.role,
  };
};

const RegistrationCodesScreenContainer = connect(mapStateToProps)(
  RegistrationCodesScreen
);

export default RegistrationCodesScreenContainer;
